@if (loading) {
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
} @else {
  <div>
    <table [dataSource]="entries" class="w100 table marg-bot8 pad4" mat-table>
      <!-- attribute column -->
      <ng-container matColumnDef="attribute">
        <th mat-header-cell *matHeaderCellDef> attribute</th>
        <td mat-cell *matCellDef="let element">{{ element[0] }}</td>
      </ng-container>

      <!-- value column -->
      <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef> value</th>
        <td mat-cell *matCellDef="let element">

          @if (element[0] === 'Verweise') {
            <app-reference-table [entry]="element[1]" [editMode]="false" [clickableRefs]="true"></app-reference-table>
          } @else {

            <span
              [class.table-all]="element[1]==='NONE'"
              [class.table-a0]="element[1]==='A0'"
              [class.table-a1]="element[1]==='A1'"
              [class.table-a2]="element[1]==='A2'"
              [class.table-b1]="element[1]==='B1'"
              [class.table-b2]="element[1]==='B2'"
              [class.table-c1]="element[1]==='C1'"
              [class.table-c2]="element[1]==='C2'">
                {{ sharedService.show(element[1]) }}
            </span>
          }

        </td>
      </ng-container>

      <!-- data rows -->
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <!-- no entries row -->
      <tr class="text-center" *ngIf="entries?.length === 0">
        <td [attr.colspan]="displayedColumns.length">
          No entries available
        </td>
      </tr>
    </table>
  </div>
}
